import { contactContent } from '@/mocks/homeData';

const CONTACT_FORM_URL = 'https://readdy.ai/api/form/d9l3138h9dsfbuoi6meg';

export default function Contact() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();

    if (honeypot) {
      const successMsg = document.getElementById('contact-success');
      if (successMsg) successMsg.classList.remove('hidden');
      return;
    }

    const formData = new FormData(form);

    try {
      const res = await fetch(CONTACT_FORM_URL, {
        method: 'POST',
        body: formData,
      });
      const text = await res.text();
      try {
        const parsed = JSON.parse(text);
        if (parsed?.code === 'OK') {
          const successMsg = document.getElementById('contact-success');
          if (successMsg) successMsg.classList.remove('hidden');
          const errorMsg = document.getElementById('contact-error');
          if (errorMsg) errorMsg.classList.add('hidden');
          form.reset();
        } else {
          const serverMsg = parsed?.meta?.message || parsed?.message || text;
          const errorEl = document.getElementById('contact-error-msg');
          if (errorEl) errorEl.textContent = serverMsg || '提交失败，请稍后重试';
          const errorMsg = document.getElementById('contact-error');
          if (errorMsg) errorMsg.classList.remove('hidden');
        }
      } catch {
        const errorEl = document.getElementById('contact-error-msg');
        if (errorEl) errorEl.textContent = text || '提交失败';
        const errorMsg = document.getElementById('contact-error');
        if (errorMsg) errorMsg.classList.remove('hidden');
      }
    } catch {
      const errorEl = document.getElementById('contact-error-msg');
      if (errorEl) errorEl.textContent = '网络错误，请稍后重试';
      const errorMsg = document.getElementById('contact-error');
      if (errorMsg) errorMsg.classList.remove('hidden');
    }
  };

  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">{contactContent.title}</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            {contactContent.subtitle}
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 md:gap-12 max-w-[960px] mx-auto">
          <div className="flex-1">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {contactContent.desc}
            </p>

            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-500">电子邮箱</p>
                  <p className="text-sm font-medium text-foreground-800">{contactContent.email}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100/70 text-accent-600 shrink-0">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-500">微信公众号</p>
                  <p className="text-sm font-medium text-foreground-800">{contactContent.wechat}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100/70 text-secondary-600 shrink-0">
                  <i className="ri-question-answer-line text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-500">QQ客服</p>
                  <p className="text-sm font-medium text-foreground-800">{contactContent.qq}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <form
              onSubmit={handleSubmit}
              data-readdy-form=""
              className="bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6 space-y-4"
            >
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  您的称呼 <span className="text-primary-500">*</span>
                </label>
                <input
                  type="text"
                  id="contact-name"
                  name="name"
                  required
                  className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
                  placeholder="请输入您的称呼"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  电子邮箱 <span className="text-primary-500">*</span>
                </label>
                <input
                  type="email"
                  id="contact-email"
                  name="email"
                  required
                  className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
                  placeholder="请输入您的邮箱"
                />
              </div>
              <div>
                <label htmlFor="contact-type" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  咨询类型
                </label>
                <select
                  id="contact-type"
                  name="type"
                  className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors cursor-pointer"
                >
                  <option value="爆料投稿">爆料投稿</option>
                  <option value="商务合作">商务合作</option>
                  <option value="问题反馈">问题反馈</option>
                  <option value="其他咨询">其他咨询</option>
                </select>
              </div>
              <div>
                <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  留言内容 <span className="text-primary-500">*</span>
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors resize-none"
                  placeholder="请输入您的留言（不超过500字）"
                ></textarea>
                <p className="text-xs text-foreground-500 mt-1">限500字以内</p>
              </div>

              <div className="honeypot-field">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>

              <button
                type="submit"
                className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line text-lg"></i>
                发送消息
              </button>

              <div id="contact-success" className="hidden p-3 rounded-md bg-secondary-100 text-secondary-700 text-sm text-center">
                消息已发送，我们会在24小时内回复您！
              </div>
              <div id="contact-error" className="hidden p-3 rounded-md bg-primary-100 text-primary-700 text-sm text-center">
                <span id="contact-error-msg">提交失败，请稍后重试</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}